<template>
  <div class="account-and-safe">
    <el-form class="form" :model="formData" :rules="rules" label-position="top" ref="formRef">
      <el-form-item label="旧密码" prop="oldPwd" class="w-p-100">
        <el-input type="password" placeholder="请输入" v-model.trim="formData.oldPwd"></el-input>
      </el-form-item>
      <el-form-item label="新密码" prop="newPwd" class="w-p-100">
        <el-input type="password" placeholder="请输入" v-model.trim="formData.newPwd"></el-input>
      </el-form-item>
      <el-form-item label="确认密码" prop="confirmPwd" class="w-p-100">
        <el-input type="password" placeholder="请输入" v-model.trim="formData.confirmPwd"></el-input>
      </el-form-item>
      <div class="bottom-btn">
        <el-button class="color-orange" type="primary" v-loading="btnLoading" @click="handleConfirm">更新信息</el-button>
      </div>
    </el-form>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import JSEncrypt from "jsencrypt";

export default {
  props: {
    userInfo: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    const pwdValidator = (rule, value, cb) => {
      if (value.length < 6) {
        return cb(new Error('密码位数必须大于6位'))
      }
      cb()
    }
    const newPwdValidator = (rule, value, cb) => {
      if (value == this.formData.oldPwd) {
        return cb(new Error('新密码不能和旧密码一致'))
      }
      cb()
    }
    const confirmPwdValidator = (rule, value, cb) => {
      if (value != this.formData.newPwd) {
        return cb(new Error('确认密码与新密码不一致'))
      }
      cb()
    }
    return {
      btnLoading: false,

      formData: {
        oldPwd: '',
        newPwd: '',
        confirmPwd: ''
      },
      rules: {
        oldPwd: [
          { required: true, message: '请输入旧密码', trigger: 'blur' },
          { validator: pwdValidator, trigger: 'blur' },
        ],
        newPwd: [
          { required: true, message: '请输入新密码', trigger: 'blur' },
          { validator: pwdValidator, trigger: 'blur' },
          { validator: newPwdValidator, trigger: 'blur' },
        ],
        confirmPwd: [
          { required: true, message: '请输入确认密码', trigger: 'blur' },
          { validator: pwdValidator, trigger: 'blur' },
          { validator: confirmPwdValidator, trigger: 'blur' },
        ],
      }
    }
  },
  methods: {
    ...mapActions(['fetchData']),
    // 确认操作
    handleConfirm() {
      this.$refs.formRef.validate(pass => {
        if (pass) {
          this.updatePassword()
        } else {
          this.$message.error('请按要求填写信息')
        }
      })
    },
    // 更改密码
    updatePassword() {
      let url = 'USER.POST_CHANGE_PWD'
      let params = {
        id: this.userInfo.id,
        oldPwd: this.getEncrypt(this.formData.oldPwd),
        password: this.getEncrypt(this.formData.newPwd)
      }
      
      this.btnLoading = true
      this.fetchData({ url, params, method: 'post' }).then((res) => {
        if (res.success) {
          this.$message.success('修改成功！')
          for(let key in this.formData) {
            this.formData[key] = ''
          }
        } else {
          this.$message.error('修改失败！')
        }
      }).finally(() => {
        this.btnLoading = false
      })
    },
    // 密码加密
    getEncrypt(data) {
      let publickKey =
        "MIGfMA0GCSqGSIb3DQEBAQUAA4GNADCBiQKBgQCMKvDoYmZuEUIX5iG6b2b1GuJUYaqAMGm+NGGlTO59KP9ccqbW6KOSu0Cp3sewbXQnzIg5QxlKzySPH9p/SlnQIAT3eMhPRAj4iP6QZ8ZH6WzVquNTNZSHomQ03Pt/Ffx1AogBQVMgdMHFTN18L6kud3NSXGqqGx1ds+q5rrVYSwIDAQAB";
      let crypt = new JSEncrypt();
      crypt.setPublicKey(publickKey);
      let ret = crypt.encrypt(data);
      return ret;
    },
  }
}
</script>

<style lang="less" scoped>
.account-and-safe {
  width: 100%;
  .form {
    margin: 0 auto;
    margin-top: 50px;
    width: 400px;
  }
  .bottom-btn {
    margin-top: 50px;
    text-align: center;
  }
}

.color-orange {
  background-color: rgba(246, 100, 1, 1);
}
</style>